//Groups

// 1: ambition, performance
// 2: adaptability, strategic
// 3: analytical
// 4: learningagility
// 5: courage, persuasion, command
// 6: advisor, developer
// 7: focus
// 8: confidence, growth
// 9: networker
// 10: competition
// 11: persistence
// 12: problemsolver
// 13: individualizer, relator
// 14: responsibility
// 15: safety
// 16: service, responsiveness, mission
// 17: discipline, operational
// 18: team, communication

/*
let dimensions = {};

_.each([
  ['ambition', 'performance'],
  ['adaptability', 'strategic'],
  ['analytical'],
  ['learningagility'],
  ['courage', 'persuasion', 'command'],
  ['advisor', 'developer'],
  ['focus'],
  ['confidence', 'growth'],
  ['networker'],
  ['competition'],
  ['persistence'],
  ['problemsolver'],
  ['individualizer', 'relator'],
  ['responsibility'],
  ['safety'],
  ['service', 'responsiveness', 'mission'],
  ['discipline', 'operational'],
  ['team', 'communication']
], (dimensionGroup, dimensionGroupIndex) => {
  const dimensionFamily = generateUnsafeHash();

  _.each(dimensionGroup, dimension => {
    const dimensionId = generateUnsafeHash();
    const legacyId = dimensionGroupIndex + 1;

    dimensions[dimensionId] = {
      id: dimensionId,
      dimensionFamily,
      name: dimension,
      label: dimension,//need to replace this
      categoryId: "",
      legacyId,
    }
  });
});


let dimensionFamilies = _.map(dimensions, 'dimensionFamily');

_.each(dimensionFamilies, familyId => {
	let dimensionsInThisFamily = _.filter(dimensions, { dimensionFamily: familyId });
	mappedFamilies[familyId] = {
		id: familyId,
		name: dimensionsInThisFamily[0].name,
		label: dimensionsInThisFamily[0].label,
		coreDimension: dimensionsInThisFamily[0].id,
		allDimensions: _.map(dimensionsInThisFamily, 'id')


*/

export const dimensionFamilies = {
  "zuv1zj": {
    "id": "zuv1zj",
    "name": "m1",
    "label": "M-1",
    "coreDimension": "eb2x38",
    "allDimensions": [
      "eb2x38",
      "enzx1e"
    ],
    "categoryId": "1",
  },
  "epac06": {
    "id": "epac06",
    "name": "c1",
    "label": "C-1",
    "coreDimension": "g5ii0e",
    "allDimensions": [
      "g5ii0e",
      "x3ycav"
    ],
    "categoryId": "3",
  },
  "krqa3d": {
    "id": "krqa3d",
    "name": "c2",
    "label": "C-2",
    "coreDimension": "jrsl97",
    "allDimensions": [
      "jrsl97"
    ],
    "categoryId": "3",
  },
  "vz89qw": {
    "id": "vz89qw",
    "name": "c4",
    "label": "C-4",
    "coreDimension": "qxgy0i",
    "allDimensions": [
      "qxgy0i"
    ],
    "categoryId": "3",
  },
  "atracy": {
    "id": "atracy",
    "name": "e1",
    "label": "E-1",
    "coreDimension": "zavm2z",
    "allDimensions": [
      "zavm2z",
      "ep6tj6",
      "busvn2"
    ],
    "categoryId": "4",
  },
  "b62kuo": {
    "id": "b62kuo",
    "name": "i1",
    "label": "I-1",
    "coreDimension": "itypp1",
    "allDimensions": [
      "itypp1",
      "y93iyg"
    ],
    "categoryId": "2",
  },
  "ybx7l1": {
    "id": "ybx7l1",
    "name": "e2",
    "label": "E-2",
    "coreDimension": "c54tc9",
    "allDimensions": [
      "c54tc9",
    ],
    "categoryId": "4",
  },
  "aof9jh": {
    "id": "aof9jh",
    "name": "m2",
    "label": "M-2",
    "coreDimension": "up7jjs",
    "allDimensions": [
      "up7jjs",
      "u0uvji"
    ],
    "categoryId": "1",
  },
  "wbxc32": {
    "id": "wbxc32",
    "name": "i2",
    "label": "I-2",
    "coreDimension": "t9sjaz",
    "allDimensions": [
      "t9sjaz"
    ],
    "categoryId": "2",
  },
  "bfbovn": {
    "id": "bfbovn",
    "name": "m3",
    "label": "M-3",
    "coreDimension": "jctmmw",
    "allDimensions": [
      "jctmmw"
    ],
    "categoryId": "1",
  },
  "zx07x6": {
    "id": "zx07x6",
    "name": "m4",
    "label": "M-4",
    "coreDimension": "moo90r",
    "allDimensions": [
      "moo90r",
    ],
    "categoryId": "1",
  },
  "lrakq9": {
    "id": "lrakq9",
    "name": "c4",
    "label": "C-4",
    "coreDimension": "p0ruta",
    "allDimensions": [
      "p0ruta",
    ],
    "categoryId": "3",
  },
  "b07r6p": {
    "id": "b07r6p",
    "name": "i3",
    "label": "I-3",
    "coreDimension": "ltu5rt",
    "allDimensions": [
      "ltu5rt",
      "lc4930"
    ],
    "categoryId": "2",
  },
  "yhbcgm": {
    "id": "yhbcgm",
    "name": "e3",
    "label": "E-3",
    "coreDimension": "oyzo55",
    "allDimensions": [
      "oyzo55",
    ],
    "categoryId": "4",
  },
  "zx6iaq": {
    "id": "zx6iaq",
    "name": "e4",
    "label": "E-4",
    "coreDimension": "qsptzl",
    "allDimensions": [
      "qsptzl"
    ],
    "categoryId": "4",
  },
  "z0m0xd": {
    "id": "z0m0xd",
    "name": "m5",
    "label": "M-5",
    "coreDimension": "vjtt0z",
    "allDimensions": [
      "vjtt0z",
      "ceokld",
      "b0e6f1"
    ],
    "categoryId": "1",
  },
  "f5yhku": {
    "id": "f5yhku",
    "name": "e5",
    "label": "E-5",
    "coreDimension": "fdwtt7",
    "allDimensions": [
      "fdwtt7",
      "d22k6w"
    ],
    "categoryId": "4",
  },
  "aviw3m": {
    "id": "aviw3m",
    "name": "i4",
    "label": "I-4",
    "coreDimension": "hp8cen",
    "allDimensions": [
      "hp8cen",
      "xmstja"
    ],
    "categoryId": "2",
  },
  "jnny5f": {
    "id": "jnny5f",
    "name": "i5",
    "label": "I-5",
    "coreDimension": "tuuwro",
    "allDimensions": [
      "tuuwro"
    ],
    "categoryId": "2"
  }
}

export const dimensions = {
  "eb2x38": {
    "id": "eb2x38",
    "dimensionFamily": "zuv1zj",
    "name": "ambition",
    "label": "Ambition",
    "categoryId": "1",
    "legacyId": 1,
    "competencyIndex": "10",
  },
  "enzx1e": {
    "id": "enzx1e",
    "dimensionFamily": "zuv1zj",
    "name": "performance",
    "label": "Performance",
    "categoryId": "1",
    "legacyId": 1,
    "competencyIndex": "10",
  },
  "g5ii0e": {
    "id": "g5ii0e",
    "dimensionFamily": "epac06",
    "name": "adaptability",
    "label": "Adaptability",
    "categoryId": "3",
    "legacyId": 2,
    "competencyIndex": "4",
  },
  "x3ycav": {
    "id": "x3ycav",
    "dimensionFamily": "epac06",
    "name": "strategic",
    "label": "Strategic",
    "categoryId": "3",
    "legacyId": 2,
    "competencyIndex": "4",
  },
  "jrsl97": {
    "id": "jrsl97",
    "dimensionFamily": "krqa3d",
    "name": "analytical",
    "label": "Analytical",
    "categoryId": "3",
    "legacyId": 3,
    "competencyIndex": "6",
  },
  "qxgy0i": {
    "id": "qxgy0i",
    "dimensionFamily": "vz89qw",
    "name": "learningagility",
    "label": "Learning Agility",
    "categoryId": "3",
    "legacyId": 4,
    "competencyIndex": "4",
  },
  "zavm2z": {
    "id": "zavm2z",
    "dimensionFamily": "atracy",
    "name": "courage",
    "label": "Courage",
    "categoryId": "4",
    "legacyId": 5,
    "competencyIndex": "9",
  },
  "ep6tj6": {
    "id": "ep6tj6",
    "dimensionFamily": "atracy",
    "name": "persuasion",
    "label": "Persuasion",
    "categoryId": "4",
    "legacyId": 5,
    "competencyIndex": "9",
  },
  //The command dimension is no longer used, but older assessments have scores for it so we leave it here
  "busvn2": {
    "id": "busvn2",
    "dimensionFamily": "atracy",
    "name": "command",
    "label": "Command",
    "categoryId": "4",
    "legacyId": 5,
    "competencyIndex": "9",
  },
  "itypp1": {
    "id": "itypp1",
    "dimensionFamily": "b62kuo",
    "name": "advisor",
    "label": "Advisor",
    "categoryId": "2",
    "legacyId": 6,
    "competencyIndex": "6",
  },
  "y93iyg": {
    "id": "y93iyg",
    "dimensionFamily": "b62kuo",
    "name": "developer",
    "label": "Developer",
    "categoryId": "2",
    "legacyId": 6,
    "competencyIndex": "6",
  },
  "c54tc9": {
    "id": "c54tc9",
    "dimensionFamily": "ybx7l1",
    "name": "focus",
    "label": "Focus",
    "categoryId": "4",
    "legacyId": 7,
    "competencyIndex": "8",
  },
  "up7jjs": {
    "id": "up7jjs",
    "dimensionFamily": "aof9jh",
    "name": "confidence",
    "label": "Confidence",
    "categoryId": "1",
    "legacyId": 8,
    "competencyIndex": "9",
  },
  "u0uvji": {
    "id": "u0uvji",
    "dimensionFamily": "aof9jh",
    "name": "growth",
    "label": "Growth",
    "categoryId": "1",
    "legacyId": 8,
    "competencyIndex": "9",
  },
  "t9sjaz": {
    "id": "t9sjaz",
    "dimensionFamily": "wbxc32",
    "name": "networker",
    "label": "Networker",
    "categoryId": "2",
    "legacyId": 9,
    "competencyIndex": "7",
  },
  "jctmmw": {
    "id": "jctmmw",
    "dimensionFamily": "bfbovn",
    "name": "competition",
    "label": "Competition",
    "categoryId": "1",
    "legacyId": 10,
    "competencyIndex": "1",
  },
  "moo90r": {
    "id": "moo90r",
    "dimensionFamily": "zx07x6",
    "name": "persistence",
    "label": "Persistence",
    "categoryId": "1",
    "legacyId": 11,
    "competencyIndex": "7",
  },
  "p0ruta": {
    "id": "p0ruta",
    "dimensionFamily": "lrakq9",
    "name": "problemsolver",
    "label": "Problem Solver",
    "categoryId": "3",
    "legacyId": 12,
    "competencyIndex": "5",
  },
  "ltu5rt": {
    "id": "ltu5rt",
    "dimensionFamily": "b07r6p",
    "name": "individualizer",
    "label": "Individualizer",
    "categoryId": "2",
    "legacyId": 13,
    "competencyIndex": "2",
  },
  "lc4930": {
    "id": "lc4930",
    "dimensionFamily": "b07r6p",
    "name": "relator",
    "label": "Relator",
    "categoryId": "2",
    "legacyId": 13,
    "competencyIndex": "3",
  },
  "oyzo55": {
    "id": "oyzo55",
    "dimensionFamily": "yhbcgm",
    "name": "responsibility",
    "label": "Responsibility",
    "categoryId": "4",
    "legacyId": 14,
    "competencyIndex": "8",
  },
  "qsptzl": {
    "id": "qsptzl",
    "dimensionFamily": "zx6iaq",
    "name": "safety",
    "label": "Safety",
    "categoryId": "4",
    "legacyId": 15
  },
  "vjtt0z": {
    "id": "vjtt0z",
    "dimensionFamily": "z0m0xd",
    "name": "service",
    "label": "Service",
    "categoryId": "1",
    "legacyId": 16,
    "competencyIndex": "2",
  },
  "ceokld": {
    "id": "ceokld",
    "dimensionFamily": "z0m0xd",
    "name": "responsiveness",
    "label": "Responsiveness",
    "categoryId": "1",
    "legacyId": 16,
    "competencyIndex": "2",
  },
  "b0e6f1": {
    "id": "b0e6f1",
    "dimensionFamily": "z0m0xd",
    "name": "mission",
    "label": "Mission",
    "categoryId": "1",
    "legacyId": 16,
    "competencyIndex": "2",
  },
  "fdwtt7": {
    "id": "fdwtt7",
    "dimensionFamily": "f5yhku",
    "name": "discipline",
    "label": "Discipline",
    "categoryId": "4",
    "legacyId": 17,
    "competencyIndex": "1",
  },
  "d22k6w": {
    "id": "d22k6w",
    "dimensionFamily": "f5yhku",
    "name": "operational",
    "label": "Operational",
    "categoryId": "4",
    "legacyId": 17,
    "competencyIndex": "1",
  },
  "hp8cen": {
    "id": "hp8cen",
    "dimensionFamily": "aviw3m",
    "name": "team",
    "label": "Team",
    "categoryId": "2",
    "legacyId": 18,
    "competencyIndex": "3",
  },
  "xmstja": {
    "id": "xmstja",
    "dimensionFamily": "aviw3m",
    "name": "communication",
    "label": "Communication",
    "categoryId": "2",
    "legacyId": 18,
    "competencyIndex": "3",
  },
  "tuuwro": {
    "id": "tuuwro",
    "dimensionFamily": "jnny5f",
    "name": "customerfocus",
    "label": "Customer Focus",
    "categoryId": "2",
    "legacyId": 19,
    "competencyIndex": "2",
  }
}



// WEBPACK FOOTER //
// ./src/data/dimensions.js